import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.tipReason}}\n  {{this.tipIcon}}\n  {{this.tipReason}}\n{{/if}}",{ moduleName: "discourse/components/input-tip.hbs" })